import { useGetReportDetailsQuery } from '@/app/Report/api/reportApi';
import { useNavigate, useParams } from 'react-router-dom';

const Details = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const { data: reportData, isFetching } = useGetReportDetailsQuery(id!, {
    skip: !id
  });
  if (isFetching) return '';
  if (reportData && reportData.code === 40301) navigate('/');
  if (reportData && reportData.code === 40401) navigate('/errors/404');

  return (
    <div>
      <div dangerouslySetInnerHTML={{ __html: reportData?.data ?? '' }} />
    </div>
  );
};

export default Details;
